export const DEFAULT_Z_INDEX = 1_000_000
export const POLICY_TYPES = ['cookie', 'privacy', 'custom'] as const
export const PAGE_SETTINGS = ['all', 'include', 'exclude'] as const
export const _20MB = 20 * 1024 * 1024
